import { useState, useEffect, Dispatch, SetStateAction } from "react";
import { logClientError } from "../helpers/clientLogger";

export const useLocalStorage = <T>(
  key: string,
  initialValue: T
): [T, Dispatch<SetStateAction<T>>] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      logClientError(error, { surface: "storage", severity: "warn" });
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue));
    } catch (error) {
      console.error(error);
      logClientError(error, { surface: "storage", severity: "warn" });
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
};
